import { render } from "./AudioToggle.vue?vue&type=template&id=12bce2a8&scoped=true"
import script from "./AudioToggle.vue?vue&type=script&lang=js"
export * from "./AudioToggle.vue?vue&type=script&lang=js"

import "./AudioToggle.vue?vue&type=style&index=0&id=12bce2a8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bce2a8"]])

export default __exports__